import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';
import { BasePage } from '../../base-page';
import { CityModel } from 'src/app/models/store/city.model';

@Component({
  selector: 'app-edit-city',
  templateUrl: './edit-city.component.html',
  styleUrl: './edit-city.component.scss',
  standalone: false
})
export class EditCityComponent extends BasePage implements OnInit {

  public model: CityModel = {
    isEnabled: true,
    order: 1,
  }

  constructor(private mApiService: ApiService, private mRouter: Router, private mMessageService: MessageService, activatedRoute: ActivatedRoute) {
    super();
    this.model.id = activatedRoute.snapshot.params['id'] !== 'new' ? activatedRoute.snapshot.params['id'] : undefined;
  }

  ngOnInit(): void {
    this.isBusy = true;
    if (this.model.id) {
      this.mApiService.get<CityModel>(`/api/admin/city/${this.model.id}`).subscribe({
        next: r => {
          this.model = r;
          this.isBusy = false;
        }, error: () => this.isBusy = false
      });
    } else {
      this.isBusy = false;
    }
  }

  public save() {
    this.isBusy = true;


    this.mApiService.post<CityModel, CityModel>('/api/admin/city', this.model).subscribe({
      next: r => {
        this.isBusy = false;

        if (!this.model.id) {
          this.mRouter.navigate([`/cities/edit/${r.id}`]);
        }

        this.model = r;
        this.mMessageService.addMessage({ text: 'Город сохранен', type: this.mMessageService.types.success });
      }, error: () => this.isBusy = false
    });
  }


  public clickmap($event: any) {
    const coords = $event.event.get('coords') as Array<number>;
    this.model.location = {
      lat: coords[0],
      lon: coords[1]
    }
  }
}
